import Alpine from "alpinejs";

const data = (customData = {}) => ({
  /**
   *  Data
   */

  checkboxIdPrefix: 'item',
  totalCount: 0,
  selectedCount: 0,
  isAllChecked: false,
  selectedItemIds: [],
  excludedItemIds: [],

  /**
   *  Targets
   */

  targets: {
    selectAll: {
      ['x-model']: 'isAllChecked',
      ['x-on:click']: 'toggleSelectAll()',
    },
    selectedIds: {
      ['x-model']: 'selectedItemIds',
    },
    excludedIds: {
      ['x-model']: 'excludedItemIds',
    },
  },

  /**
   *  Main & Event Callback
   */

  get checkboxElements() {
    const elements = document.querySelectorAll(
      `[id^=${this.checkboxIdPrefix}-]`
    )
    return [...elements]
  },

  toggleSelectAll() {
    this.isAllChecked = !this.isAllChecked
    this.selectedItemIds = []
    this.excludedItemIds = []
    this.checkboxElements.forEach((el) => {
      if(el.disabled == false) { el.checked = this.isAllChecked }
      el.dispatchEvent(new Event('change'))
    })
    this.selectedCount = this.isAllChecked === true ? this.totalCount : 0
  },

  isCheckboxChecked(itemId, disabled = false) {
    let check = false

    if (disabled == true) {
      check = false
    } else if (this.isAllChecked && !this.excludedItemIds.includes(itemId)) {
      check = true
    } else if (!this.isAllChecked && this.selectedItemIds.includes(itemId)) {
      check = true
    }
    return check
  },

  toggleCheckbox(itemId) {
    if (this.isAllChecked) {
      if (this.excludedItemIds.includes(itemId)) {
        this.excludedItemIds.splice(this.excludedItemIds.indexOf(itemId), 1)
        this.selectedCount++
      } else {
        this.excludedItemIds.push(itemId)
        this.selectedCount--
      }
    } else {
      if (this.selectedItemIds.includes(itemId)) {
        this.selectedItemIds.splice(this.selectedItemIds.indexOf(itemId), 1)
        this.selectedCount--
      } else {
        this.selectedItemIds.push(itemId)
        this.selectedCount++
      }
    }
    if (this.excludedItemIds.length === this.totalCount) {
      this.isAllChecked = false
    }
  },

  ...customData,
})

Alpine.data('multipleCheckboxesData', data)
export default data
